<div class="error" (click)="click()"></div>
